<template>
    <nav class="navbar navbar-expand-md navbar-light fixed-top" :class="{'shrunk': shrinkNavbar}">
        <div class="container-fluid">
            <a class="navbar-brand" href="#">
                <img src="assets/jvs-logo.png" alt="logo">
            </a>
            <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#collapsingNavbarMenu">
                <span class="fas fa-bars"></span>
            </button>
            <div class="collapse navbar-collapse" id="collapsingNavbarMenu">
                <ul class="navbar-nav ml-auto">
                    <li class="nav-item" v-for="(item, key) in menu" :key="'navbar_menu_'+key">
                        <a class="nav-link" :href="'#'+item">{{item}}</a>
                    </li>
                </ul>
            </div>
        </div>
    </nav>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
    data() {
        return {
            SCROLL_POSITION_Y_BREAKPOINT: 50,
            shrinkNavbar: false,
            menu: ['about', 'resume', 'portfolio'],
            menuTargets: {}
        }
    },
    computed: {
        ...mapState(['scrollPosition_y'])
    },
    methods:{
        ...mapActions(['getScrollPosition']),
        toggleShrinkNavbar: function() {
            this.getScrollPosition();
            if (this.scrollPosition_y < this.SCROLL_POSITION_Y_BREAKPOINT) {
                this.shrinkNavbar = false;
            } 
            else {
                this.shrinkNavbar = true;
            }
        }
    },
    mounted() {
        this.$nextTick(function() {
            window.addEventListener('scroll', this.getScrollPosition);
            window.addEventListener('scroll', this.toggleShrinkNavbar);
            this.getScrollPosition();
            this.toggleShrinkNavbar();
        });
    },
    beforeDestroy() {
        window.removeEventListener('scroll', this.getScrollPosition);
        window.removeEventListener('scroll', this.toggleShrinkNavbar);
    }
}
</script>

<style lang="scss" scoped>
.navbar {
    background-color: transparent!important;

    /* Shrunk navbar on screen resize */
    &.shrunk {
        background-color: rgba($colour-white, 0.9)!important;

        img {
            max-height: 2em;
        }

        .navbar-brand {
            &:hover {
                padding-top: 0;

                img {
                    max-height: 2.2em;
                }
            }
        }
    }

    .navbar-toggler {
        border: none;
        color: $colour-blue-primary;
    }

    .nav-link{
        &:hover {
            transform: scale(1.03) translate(0px, 1px);
        }

        &.active {
            color: $colour-blue-primary;
            font-weight: 700;
        }
    }
}

.navbar-brand {
    animation: fadeIn 4s;
}

img {
    width: auto;
    max-height: 4.65em;
}

img:hover {
    filter: drop-shadow(0 0.4rem 0.3rem $colour-blue-light);
}
</style>
